/* global  moment, _ */
import './style.less';
import { extend, orderBy, get } from 'lodash';
import AdminEmployeesModalTrackController from 'modals/employeesTracks';
import adminEmployeesModalTrackTemplate from 'modals/employeesTracks/index.html';

export default function($log, $state, $stateParams, $scope, $uibModal, ApiClass, UserClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.isAdmin = UserClass.isAdmin || UserClass.isTeamLeader;
  vm.profile_uid = $stateParams.employeeID || $stateParams.id;

  $scope.disableAssignTrackButton = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.assignTrack');
  $scope.disableRemoveTrackingProgressButton = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.removeTrackingProgress');

  vm.pagination = {
    currentPage: 1,
    numPerPage: 15,
    setPage: pageNo => (vm.pagination.currentPage = pageNo)
  };

  vm.toggleRow = item => {
    item.displayInfo = !item.displayInfo;
  };

  vm.removeTrack = track_id => {
    ApiClass.learningsIdTypeTypeIdDelete(
      { id: track_id, type: 'assigned', type_id: vm.profile_uid },
      {},
      { queryParams: { manage: true } }
    )
      .then(() => activate())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.assignTrack = function() {
    $uibModal
      .open({
        backdrop: true,
        size: 'lg',
        template: adminEmployeesModalTrackTemplate,
        controller: AdminEmployeesModalTrackController,
        resolve: {
          selectedEmployees: function() {
            return [{ profile_uid: vm.profile_uid }];
          }
        }
      })
      .result.then(
        success => {
          if (success === 'success') activate();
        },
        error => {
          if (error === 'backdrop click') return;
          $log.error(error);
          throw error;
        }
      );
  };

  function activate() {
    $log.debug('Track Progress Component Activated');
    vm.loaded = false;
    vm.error = {};

    ApiClass.learningsGet(
      {},
      {},
      {
        queryParams: {
          profile_uid: vm.profile_uid,
          filters: JSON.stringify({
            active: true,
            requireProgress: true
          }),
          joins: JSON.stringify({ content: true }),
          calc: JSON.stringify({ progress: true })
        }
      }
    )
      .then(({ data: { tracks } }) => {
        if (!tracks.length) {
          vm.loaded = true;
          return;
        }

        const sortedTracks = orderBy(tracks, ['name'], ['asc']);

        vm.tracks = sortedTracks;

        vm.tracks.forEach(track => {
          if (!track.content || !track.content.length) return;
          track.content.forEach(content => {
            const { type, course_id, activity_id } = content;
            switch (type) {
              case 'event' || 'course':
                extend(content, track.progress.progress.events[course_id]);
                break;
              case 'course':
                extend(content, track.progress.progress.courses[course_id]);
                break;
              case 'activity':
                const activityProgress = track.progress.progress.activities[activity_id];
                extend(content, activityProgress);
                content.status = activityProgress.completed ? 1 : 0;
                break;
              default:
                break;
            }
          });
        });

        if (vm.tracks.length) {
          vm.activeTrack = vm.tracks[0].track_id;
        }

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/progressTracks/controller.js